import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDateOnly from "../components/popups/SelectDateOnly";
import { addThousandPoint,ToggleDarkBackground,ChangeDateFormat,LoginAfterCheckLogin } from "../../components/common/Common";
import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//정산현황
const SettlementSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varSettlementsList,setSettlementsList] = useState([]);
  const searchObj = {sdate:null,edate:null};
  const [varSearchOptions,setSearchOptions] = useState(searchObj);

  //정산현황내역 호출
  const GetSettlementList = async(searchObj) => {
    const sendData = {branch_idx:branch_idx,searchInfo:searchObj};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_settlement_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      setSettlementsList(datas.settlements);
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    setSearchOptions(searchObj);
    GetSettlementList(searchObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    GetSettlementList(varSearchOptions);
  }

  //날짜선택 팝업창--------------------------------------------------------------------------------------
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varStudyIndex,setStudyIndex] = useState(0); 
  const onChangeDateHandler = (e,imode) => {
    setStudyIndex(imode);
    let csdate = "";
    if(imode === 0) csdate = varSearchOptions.sdate;
    else csdate = varSearchOptions.edate;
    const sdate = new Date(csdate);
    setDate(sdate);
    //팝업창 위치조정
    /* const hasbtns = document.querySelectorAll('.cal-btn');
    const toppos = hasbtns[imode];
    const offsetY = window.pageYOffset+toppos.getBoundingClientRect().top - 100;
    const popupWin = document.querySelector('.layer-pop-select-date');
    popupWin.setAttribute('style',`top:${offsetY}px`); */
    //팝업창 호출
    TogglePopupDaySelect(true);
  }
  //팝업창 - 날짜 설정값 저장
  const ChangedDate = (date,imode) => {
    if(date === "" ) date = null;
    console.log(date,imode);
    const ndate = ChangeDateFormat(date);
    if(imode === 0) setSearchOptions({...varSearchOptions,sdate:ndate});
    else setSearchOptions({...varSearchOptions,edate:ndate});
    //팝업창 닫기
    TogglePopupDaySelect(false);
  }
  //팝업창 열기/닫기
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }
  
  //결제내역페이지
  const onHistoryPageHandler = (e,st_idx) => {
    navigate(`/Branch/SettlementDetail/${st_idx}`);
  }

  return (
    <div className="vh-content settle-content">
      <HeaderBranchTitle varPageTitle={'정산 현황'} varBackString={'none'}/>
      <div className="vh-content-body">
        <div className="payment-wrap">
          <div className="center-wrap">
            <div className="search-wrap st02">
              <div className="flex">
								<p>기간</p>
                <div className="has-btn">
                  <input type="text" name="sdate" className="input-cal" value={varSearchOptions.sdate||""} placeholder="검색시작일" readOnly/>
									<button className="cal-btn" onClick={e=>onChangeDateHandler(e,0)}><img src={centerIcon} alt=""/></button>
								</div>
                -
                <div className="has-btn">
                  <input type="text" name="edate" className="input-cal" value={varSearchOptions.edate||""} placeholder="검색종료일" readOnly/>
									<button className="cal-btn" onClick={e=>onChangeDateHandler(e,1)}><img src={centerIcon} alt=""/></button>
								</div>
              </div>
            </div>
            <button type="button" onClick={e=>onSearchHandler(e)}>검색</button>

            <div className="search-ok-con">
              {varSettlementsList.map((settles,i)=>(
                <div key={'settles_'+i} className="settle-box" onClick={e=>onHistoryPageHandler(e,settles.st_idx)}>
                  <p className="tit">{`${settles.st_year}.${settles.st_month}월`} 정산 요청서</p>
                  <div className="flex">
                    <p>정산 총액</p>
                    <div><b>{addThousandPoint(settles.st_amount)}원</b></div>
                  </div>
                  <div className="flex">
                    <p>정산 현황</p>
                    <div>{settles.st_status===1?"승인대기":settles.st_status===2?"정산승인":"정산완료"}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <SelectDateOnly varStudyIndex={varStudyIndex} varDate={varDate} setDate={setDate} varPopupDaySelect={varPopupDaySelect} 
                        TogglePopupDaySelect={TogglePopupDaySelect} ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default SettlementSet;